import {useEffect, useRef} from 'react'
import {getGenericContentLink, type GenericContent} from '../../../../../../brand/lib/types/contentful'
import {animateAssetZoom} from '../../_utils/animations'
import {t} from '@github-ui/swp-core/lib/utils/localization'

import {YouTubePlayer} from '../../_shared/YouTubePlayer/YouTubePlayer'
import {MediaAsset} from '../../_shared/MediaAsset/MediaAsset'

import Styles from './Media.module.css'

type Props = {
  content: GenericContent
  location: string
  sectionIndex: number
  loading?: 'eager' | 'lazy'
}

export function Media(props: Props) {
  const {content, location, loading, sectionIndex} = props

  const {media} = content.fields
  const link = getGenericContentLink(content)

  // Animation
  const wrapperRef = useRef<HTMLDivElement>(null)
  const assetRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const elements: Element[] = []
    if (assetRef.current) elements.push(assetRef.current)

    // Animate first section on load, others when scrolled into view
    return wrapperRef.current ? animateAssetZoom(elements, wrapperRef.current, sectionIndex === 0) : undefined
  }, [sectionIndex])

  return (
    <div className={Styles.Media} ref={wrapperRef}>
      {link ? (
        <YouTubePlayer
          youtubeUrl={link.fields.href}
          heading={link.fields.text || t('Video')}
          location={location}
          poster={media?.at(0)} // Use first media asset as poster image
          loading={loading}
        />
      ) : (
        media && (
          <div ref={assetRef} data-animate="container">
            <div data-animate="item">
              <MediaAsset content={media} location={location} loading={loading} />
            </div>
          </div>
        )
      )}
    </div>
  )
}
